__turbopack_context__.v({
  "stepLayout": "styles-module-scss-module__82TZAq__stepLayout",
  "stepLayout__children": "styles-module-scss-module__82TZAq__stepLayout__children",
  "stepLayout__description": "styles-module-scss-module__82TZAq__stepLayout__description",
  "stepLayout__icon": "styles-module-scss-module__82TZAq__stepLayout__icon",
  "stepLayout__icon__modHiddenDesktop": "styles-module-scss-module__82TZAq__stepLayout__icon__modHiddenDesktop",
  "stepLayout__icon__modHiddenMobile": "styles-module-scss-module__82TZAq__stepLayout__icon__modHiddenMobile",
  "stepLayout__title": "styles-module-scss-module__82TZAq__stepLayout__title",
});
